<template>
  <div class="checklist-view">
    <ChecklistSection :item-type="itemType" :can-write="canWrite" />
  </div>
</template>

<script>
import ChecklistSection from "@/components/ChecklistSection.vue";

export default {
  name: "ChecklistView",
  components: {
    ChecklistSection,
  },
  props: {
    itemType: {
      type: String,
      default: "TODO",
    },
    canWrite: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
